import React from "react";
import ComponentHeading from "../../../common/componentHeading/ComponentHeading";
import { simplifiedApiAutomationKeyFeaturesCardData } from "../../../helper/cardsData/simplifiedApiAutomationMockData";
import KeyFeaturesCard from "../../../common/keyFeaturesCard/KeyFeaturesCard";
import { Carousel } from "primereact/carousel";

export const SimplifiedApiAutomationKeyFeatures = () => {
  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "768px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  const CarouselKeyFeatureCard = ({ cardNumber, heading, description }) => {
    return (
      <div className="p-4">
        <KeyFeaturesCard
          cardNumber={cardNumber}
          heading={heading}
          description={description}
          titleClasses="h-14"
          descriptionClasses="h-30 lg:h-32 md:h-32"
        />
      </div>
    );
  };
  return (
    <div className="component-padding max-w-screen-2x mx-auto">
      <ComponentHeading heading="Key Features" />
      <div className="mt-8 lg:mt-12">
        <Carousel
          value={simplifiedApiAutomationKeyFeaturesCardData}
          itemTemplate={CarouselKeyFeatureCard}
          numVisible={3}
          responsiveOptions={responsiveOptions}
        />
      </div>
    </div>
  );
};

export default SimplifiedApiAutomationKeyFeatures;
